import { HttpParams } from '@angular/common/http';
import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { ePartySubType, ePartyType, Order, OrderManagerService, PartiesListComponent, Party, PartyForCreation, PartyRepositoryService, ReusableParty, ReusablePartyRepositoryService, UIConfigurationService, Utilities, ValidationProblem, ValidationService } from 'reg-hub-common';
import { PartiesComponent } from '../parties/parties.component';

@Component({
    selector: 'app-assignees',
    templateUrl: './assignees.component.html',
    styleUrl: './assignees.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssigneesComponent extends PartiesComponent {
  @ViewChild(PartiesListComponent) partiesListComponent!: PartiesListComponent;

  reusableSecuredParties: ReusableParty[] = [];

  protected businessSecuredParty = ePartyType.businessSecuredParty;
  protected individualSecuredParty = ePartyType.individualSecuredParty;

  constructor(
    private reusablePartyRepo: ReusablePartyRepositoryService,
    partyRepo: PartyRepositoryService,
    uiConfigurationService: UIConfigurationService,
    orderManager: OrderManagerService,
    validationService: ValidationService) {
    super(partyRepo, uiConfigurationService, orderManager, validationService);
  }

  protected override init(order: Order): void {
    super.init(order);

    this.reusablePartyRepo.populateBaseLink([this.order.orderGroup!.corporationID]);
    var reusablePartyParams = new HttpParams().set('isVisible', true)
      .set('pageSize', 100)
      .append('PartyTypeIDs', 'BusinessSecuredParty')
      .append('PartyTypeIDs', 'IndividualSecuredParty');

    this.reusablePartyRepo.getFirstPageSubscribable(reusablePartyParams).subscribe(parties => {
      this.reusableSecuredParties = parties;
    });
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return PartiesComponent.parseErrorsForValidationState(errors, order, Utilities.isAssignee);
  }

  public override getParties(): Party[] {
    const filteredSecuredParties = this.order.parties?.filter((party: Party) => Utilities.isAssignee(party));
    return filteredSecuredParties ?? [];
  }

  override onSaving(): void {
    var partyToReplace = this.partiesListComponent.onSaving();
    if (partyToReplace) {
      partyToReplace.partySubType = ePartySubType.assignee;
      this.replaceParty(partyToReplace!);
    }
  }

  override handlePartyAddedEvent(addedParty: Party) {
    addedParty.partySubType = ePartySubType.assignee;
    super.handlePartyAddedEvent(addedParty);
  }

  override handleExistingPartySaveEvent(existingParty: PartyForCreation) {
    existingParty.partySubType = ePartySubType.assignee;
    super.handleExistingPartySaveEvent(existingParty);
  }

  override handleExistingLinkedPartySaveEvent(existingParties: PartyForCreation[]) {
    existingParties.forEach(p => p.partySubType = ePartySubType.assignee);
    super.handleExistingLinkedPartySaveEvent(existingParties);
  }

  override handlePartySavedEvent(savedParty: Party) {
    savedParty.partySubType = ePartySubType.assignee;
    super.handlePartySavedEvent(savedParty);
  }
}

